module.exports = __webpack_public_path__ + "img/组 127(2).b744fb51.png";